import { render, staticRenderFns } from "./simpleToggle.vue?vue&type=template&id=af3b12d8&"
import script from "./simpleToggle.vue?vue&type=script&lang=js&"
export * from "./simpleToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports